import * as d3 from "d3";
import { ascending, group as d3Group, descending } from "d3-array";
import { MainPage } from "../../MainPage";
import { Entidad } from "../../data/Entidad";
import { DataModuloMain } from "../../data/ModuloMain";
import { _SvAlumnoCargaMasiva, _SvAlumnoGetBoletaCalificacionesV2, _SvAlumnoNuevo } from "../../data/modulo/Alumno";
import { _SvArchivoPlantillaAlumnosObtenerExcel } from "../../data/modulo/Archivo";
import { IMapSendCincularItems, _SvNoticiaNueva } from "../../data/modulo/Noticia";
import { Router } from "../../routes/Router";
import { DateV2 } from "../../util/DateV2";
import _L from "../../util/Labels";
import { IConfigGridExcelExport, IGridExtraTableConfig, IGridRenderInfo, VentanaGrid } from "../controlD3/AVentanaGrid";
import { ElementWrapper } from "../controlD3/ElementWrapper";
import { ExcelThings } from "../controlD3/ExcelExport";
import { Fields, FormGenerator } from "../controlD3/Formulario";
import { ExcelThingsV2 } from "../controlD3/InputExcelV2";
import { ModalThings } from "../controlD3/ModalThings";
import { NotificacionV2 } from "../controlD3/NotificacionV2";
import { SelectV2 } from "../controlD3/SelectV2";
import { Table } from "../controlD3/Tabla";
import { UIUtilIconResources } from "../util/IconResourses";
import { UIUtilLang } from "../util/Language";
import { UIUtilPermission } from "../util/Permission";
import { UIUtilTime } from "../util/Time";
import { UIUtilGeneral } from "../util/Util";
import { UIUtilViewData } from "../util/ViewData";
import { UIUtilViewAlumno } from "../utilView/Alumno";
import { UIUtilViewCalificacion } from "../utilView/Calificacion";
import { UIUtilViewCircular } from "../utilView/Circular";
import { UIUtilViewGrupos } from "../utilView/Grupos";

import IAlumno = Entidad.IAlumno;
import CAccionPermiso = Entidad.CAccionPermiso;
import CModulo = Entidad.CModulo;
import CNinioMovimiento = Entidad.CNinioMovimiento;
import IElementoCalificado = UIUtilViewCalificacion.IElementoCalificado;
// import IAuxInfoEvaluaciones = UIUtilViewCalificacion.IAuxInfoEvaluaciones;
// import ICalificacion = UIUtilViewCalificacion.ICalificacion;
import CTipoEvaluacion = Entidad.CTipoEvaluacion;
import { _ProccessAndValidateBoletasData } from "../utilView/AlumnoCalificaciones/Util";
import { _ModalInfoDataList } from "../controlD3/ModalThings/ModalInfoDataList";
import { _GenerarBoletasModal } from "../utilView/AlumnoCalificaciones/GenerarBoletasModal";
import { _ModalToAProccess } from "../controlD3/ModalThings/ModalToAProccess";
import { MCicloEscolar } from "../../data/model/MCicloEscolar";
import { _DICC_CICLO_ESCOLAR } from "../../data/modulo/CicloEscolar";
import { IMonthPeriod } from "../../data/entidad/CicloEscolar";
import { _ModalSimple } from "../controlD3/ModalThings/ModalSimple";

type IAlumnoBoleta = UIUtilViewCalificacion.IAlumnoBoleta;

interface IPeriodoD extends IMonthPeriod {
    EnCicloEscolar: boolean;
}
export class UIVentanaAlumnos extends VentanaGrid<IAlumno> {
    constructor(container: d3.Selection<HTMLDivElement, undefined, HTMLElement, any>, modulo: CModulo) {
        super(container, modulo, {
            ModuloObservableToTblRefresh: [Entidad.CTipoRequest.HorarioAlumno, Entidad.CTipoRequest.Licencia],
            MaxOptionsInRow: 3,
            MaxOptionsInTop: 3,
        });
        MainPage._ReloadService(Entidad.CTipoRequest.AlumnoEstado);
    }

    protected GRID_GetTableConfigBase(): IGridRenderInfo<IAlumno> {
        return {
            IdTabla: "Alumnos",
            Title: "",
            DefaultSort: "NombreCompleto",
            IdData: "IdChild",
            MaxOptionsInRow: 3,
            MinWidth: 1400,
            MenuInRowNoCellsToIgnoreWidth: 2,
            Columns: [
                { Field: "getThumbnailURL", LabelLangKey: null, Label: "", Width: "4%", MinWidth: "30px", IsSortable: false, Align: "center", Icon: UIUtilIconResources.CGeneral.User },
                { Field: "NombreCompleto", Label: "Nombre", Width: "20%", MinWidth: "140px" },
                { Field: "Matricula", Label: "Matrícula", Width: "10%", MinWidth: "110px" },
                { Field: "FechaNacimiento", Label: "Nacimiento", Width: "10%", MinWidth: "110px" },
                { Field: "StrSexo", Label: "Sexo", Width: "10%", MinWidth: "110px" },
                { Field: "StrEstado", Label: "Estado", Width: "12%", MinWidth: "120px" },
                { Field: "NombreKinder", Label: "Escuela", Width: "15%", MinWidth: "150px" },
                { Field: "StrEscolaridad", Label: "Escolaridad", Width: "14%", MinWidth: "140px" },
                { Field: "StrGrado", Label: "Grado", Width: "10%", MinWidth: "110px" },
                { Field: "StrGrupoPrincipal", Label: "Grupo principal", Width: "12%", MinWidth: "120px" }
            ]
        };
    }

    protected GRID_GetTableConfigAdvanced(): IGridExtraTableConfig<IAlumno> {
        return {
            EvaluatorAndSubLevelsBuild: {
                OnStepCellTable: (container, datum, field: keyof IAlumno) => {
                    if (field == "NombreCompleto") {
                        UIUtilGeneral._ElementAdd_LinkToGoToPanel(container, "alumnos/alumnos/panel", datum.IdChild, datum.NombreCompleto)
                    }
                    if (field == "getThumbnailURL") {
                        UIUtilViewAlumno._UIUpdateFotoAlumno(container, datum);
                    }
                    if (field == "StrGrupoPrincipal") {
                        UIUtilViewGrupos._ApplyLblsGruposToContainer(container, datum.IdChild);
                    }
                    if (field == "FechaNacimiento") {
                        container.text(datum.getFechaNacimientoFmt)
                    }
                }
            }
        }
    }

    protected GRID_GetMenuTopGrid(): Array<Table.ITableMenuTopDefaultOptionConfig> {
        let objOpcion: Array<Table.ITableMenuTopDefaultOptionConfig> = [];

        if (this.GridHasPermisoAccion(CAccionPermiso.Agregar)) {
            objOpcion.push(
                {
                    Label: "Agregar", Callback: () => {
                        this.OpenModal_FormularioAgregar();
                    }
                },
                {
                    Label: "action_cargamasiva",
                    Callback: () => {
                        this.OpenModal_CargaMasiva();
                    }
                },
            );
        }
        return objOpcion;
    }

    protected GRID_GetSelectionDataMenuV2(menuLocation: "row" | "top-selected", dataGridSelected: IAlumno[]): Table.ITableMenuDataSelectedOptionConfig<IAlumno>[] {
        let opciones: Array<Table.ITableMenuDataSelectedOptionConfig<IAlumno>> = [];

        if (this.GridHasPermisoAccion(CAccionPermiso.Editar)) {
            opciones.push({
                Label: "Editar", MultiData: false, Callback: (datos) => {
                    this.OpenModal_FormularioEditar(datos[0]);
                }
            });
        }

        if (UIUtilPermission._HasAccionPermission(CAccionPermiso.Editar, CModulo.PanelNinioHorario)) {
            opciones.push({
                Label: "action_inscribir",
                Callback: (datos: Array<IAlumno>) => { /* this.ValidaSelect(datos) */
                    this.OpenPanelModeInscribir(datos);
                },
                GetDetails: (datos: Array<IAlumno>) => {
                    let enabled = this.AllStudentsValidToAsignSchedules(datos);
                    return {
                        Enabled: enabled.enable,
                        Description: enabled.message
                    }
                }
            })
        }

        if (UIUtilPermission._HasModulePermission(CModulo.PanelFinanzasCargosDescuentos)) {
            opciones.push({
                Label: "action_cargosdescs",
                Callback: (datos: Array<IAlumno>) => {
                    this.OpenPanelModeCargosYDescuentos(datos);
                },
                GetDetails: (datos: IAlumno[]) => {
                    let enable: boolean = true;
                    let message: string = '';
                    if (!datos.every(d => datos[0].IdKinder == d.IdKinder)) {
                        enable = false;
                        message = this.VB_GetUIStringModule("tlt_cargosdesc_fail_nosameschool")
                    }
                    else if (!UIUtilPermission._HasFinanzasModulesPermissionFromSchools(datos[0].IdKinder)) {
                        enable = false;
                        message = this.VB_GetUIStringModule("tlt_cargosdesc_fail_nofinanzas").replace("_NAME", datos[0].NombreKinder)
                    }
                    return {
                        Enabled: enable,
                        Description: message
                    }
                    //return (Util.Permission.fn_HasFinanzasModulesPermissionFromSchools(datos[0].IdKinder) && datos.every(d => datos[0].IdKinder == d.IdKinder));
                }
            });
        }

        let escuelaModuloEval = DataModuloMain._GetItemDataByName("Escuela", dataGridSelected[0].IdKinder).ModuloEval;
        let label = (escuelaModuloEval == Entidad.CTipoEvento.Evaluacion) ? "action_asignarmateria" : "action_asignlogro";

        if ((escuelaModuloEval == Entidad.CTipoEvento.Logros && UIUtilPermission._HasModulePermission(CModulo.PanelNinioLogros)) || (escuelaModuloEval == Entidad.CTipoEvento.Evaluacion && UIUtilPermission._HasModulePermission(CModulo.PanelAlumnoMaterias))) {
            opciones.push({
                Label: label,
                Callback: (datos: Array<IAlumno>) => {
                    (escuelaModuloEval == Entidad.CTipoEvento.Logros) ? this.OpenPanelModeAsignarLogros(datos) : this.OpenPanelModeAsignarMaterias(datos);
                },
                GetDetails: (datos: Array<IAlumno>) => {
                    let enabled = (escuelaModuloEval == Entidad.CTipoEvento.Logros) ? this.AllStudentsToAsignLogros(datos) : this.AllStudentsToAsignMaterias(datos);
                    return {
                        Enabled: enabled.enable,
                        Description: enabled.message
                    }
                }
            })
        }

        if (UIUtilPermission._HasModulePermission(CModulo.Circulares)) {
            opciones.push({
                Label: "action_circular",
                Callback: (data: IAlumno[]) => {
                    this.OpenModal_Circulares(data);
                },
                GetDetails: (datos: IAlumno[]) => {
                    let enable: boolean = true;
                    let message: string = '';
                    let noInactivos = datos.filter(d => d.IdChildMovimiento != Entidad.CNinioMovimiento.Activo).length;
                    if (!datos.every(d => d.IdChildMovimiento == Entidad.CNinioMovimiento.Activo)) {
                        enable = false;
                        message = this.VB_GetUIStringModule(datos.length == 1 ? "tlt_noactivestudent" : "tlt_noactivestudents").replace("_NALUMNOS", noInactivos + "")
                    }
                    return {
                        Description: message,
                        Enabled: enable
                    }
                }
            })
        }

        if (escuelaModuloEval == Entidad.CTipoEvento.Evaluacion && UIUtilPermission._HasModulePermission(CModulo.PanelAlumnoMaterias)) {
            opciones.push({
                Label: "action_generaboleta",
                Callback: (alumnos: Array<IAlumno>) => {
                    this.OpenGenerarBoletas(alumnos);
                },
                MultiData: true,
                GetDetails: (datos: IAlumno[]) => {
                    let enabled = this.AllStudentsToGetBoletas(datos);
                    return {
                        Enabled: enabled.enable,
                        Description: enabled.message
                    }
                }
            })
        }

        if (this.GridHasPermisoAccion(CAccionPermiso.Eliminar) && dataGridSelected.some(d => [CNinioMovimiento.BajaTemporal].includes(d.IdChildMovimiento))) {
            opciones.push({
                Label: "action_bajadefinit", Callback: (datos: Array<IAlumno>) => {
                    this.OpenModal_EliminarDatos(datos);
                },
                GetDetails: (datos: IAlumno[]) => {
                    let enable: boolean = true;
                    let message: string = '';

                    if (datos.length > 1) {
                        let infoBajasDefinitivas: { Disabled: boolean, DisabledMessage: string, Status?: number }[] = [];
                        datos.forEach(alumno => {
                            let infoBajaDefinitiva = UIUtilViewAlumno._GetDisableToBajaDefinitiva(alumno);
                            infoBajasDefinitivas.push(infoBajaDefinitiva);
                        })
                        let allDisabled = infoBajasDefinitivas.every(d => d.Disabled);
                        let nInProcess = infoBajasDefinitivas.filter(d => d.Status == 0).length;
                        if (allDisabled && nInProcess > 0) {
                            enable = false;
                            message = _L("alumnos.tag_bajatemp_inprocess");
                        } else if (infoBajasDefinitivas.every(d => d.Status == -1)) {
                            enable = false;
                            message = _L("general.nodisponible");
                        }
                    } else if (datos.length == 1) {
                        let bajaDefinitivaStatus = UIUtilViewAlumno._GetDisableToBajaDefinitiva(datos[0]);
                        if (bajaDefinitivaStatus.Disabled) {
                            enable = false;
                            message = bajaDefinitivaStatus.DisabledMessage;
                        }
                    }

                    return {
                        Enabled: enable,
                        Description: message
                    }
                },
            });
        }

        return opciones;
    }

    protected GRID_GetDataRequestID(): DataModuloMain.TipoRequestMonitorId {
        return Entidad.CTipoRequest.Alumno;
    }

    protected GRID_GetFilters(): Array<Table.IParametroFiltro<IAlumno>> {
        return [
            { Label: "Nombre", Field: "Nombre" },
            { LabelLangKey: "d_field_appaterno", Field: "ApPaterno" },
            { LabelLangKey: "d_field_apmaterno", Field: "ApMaterno" },
            { Label: "Matrícula", Field: "Matricula" },
            { Label: "Fecha de nacimiento", Field: "FechaNacimiento", Type: "date", MaxDate: new Date().toISOString() },
            {
                LabelLangKey: "d_field_strsexo",
                Field: "Sexo",
                Type: "select",
                Options: UIUtilViewData._GetList_Sexo()
            },
            {
                LabelLangKey: "d_field_strestado",
                Field: "IdChildMovimiento",
                Type: "select",
                Options: UIUtilViewData._GetList_EstadosMovimientos()
                    .filter(d => ((d.Id == CNinioMovimiento.Activo) || (d.Id == CNinioMovimiento.Preinscripcion) || (d.Id == CNinioMovimiento.BajaTemporal)))
            },
            { Label: "Escolaridad", Field: "StrEscolaridad" },
            { Label: "Grado", Field: "StrGrado" },
            {
                Label: "Grupo principal", Field: "StrGrupoPrincipal", Type: "text",
                OnGetValueToMatch: (dato: IAlumno) => dato.StrGrupoPrincipalNames
            },
        ];
    }





    // **********************************************************************************************
    // FORMULARIOS MODAL
    // **********************************************************************************************

    private OpenModal_FormularioAgregar() {
        this.GridOpenModal_ActionFormToAGridData({
            Action: CAccionPermiso.Agregar,
            GetForm: () => UIUtilViewAlumno._GetAlumnoForm(CAccionPermiso.Agregar, this.modulo as any),
            OnAccept: async (form, modalThings) => {
                let dataForm: UIUtilViewAlumno.IAlumnoForm = form._Data;
                dataForm.FechaNacimiento = UIUtilViewAlumno._GetDtNacimientoFixedTZ(dataForm);
                return _SvAlumnoNuevo((dataForm as IAlumno), dataForm.Foto);
            }
        })
    }

    // FIXME
    private OpenModal_FormularioEditar(datoOrigin: IAlumno) {
        this.GridOpenModal_ActionFormToAGridData({
            Action: CAccionPermiso.Editar,
            IdsEscuelas: [datoOrigin.IdKinder],
            AutoReloadGridRequestOnFinally: false, // Se aplica en utilView.Alumno.s_ProcesoFinal_ActualizarAlumno
            GetForm: () => UIUtilViewAlumno._GetAlumnoForm(CAccionPermiso.Editar, this.modulo as any, datoOrigin),
            OnAccept: async (form, mt) => {
                let dataForm = form._Data;
                if (dataForm.IdChildMovimiento == CNinioMovimiento.Activo && datoOrigin.IdChildMovimiento != dataForm.IdChildMovimiento) {
                    if (!UIUtilViewAlumno._NotiFalloEditEstadoYGrado(form._DataOrigin.IdChildMovimiento, form._DataOrigin.IdGrado, dataForm.IdGrado)) {
                        return null;
                    }
                    let movementChildValidity = UIUtilViewAlumno._ValidarTutorYHorario(datoOrigin);
                    if (!movementChildValidity.IsValid) {
                        let resStepsGuide = await UIUtilViewAlumno._TutorYHorarioStepGuideForm(movementChildValidity.SpecificErr, dataForm.IdChild, datoOrigin.IdKinder);
                        if (resStepsGuide) mt.Modal._Ocultar();
                        return null;
                    }
                }
                dataForm.FechaNacimiento = UIUtilViewAlumno._GetDtNacimientoFixedTZ(dataForm);
                let res = await UIUtilViewAlumno._ProcesoFinal_ActualizarAlumno(datoOrigin, dataForm);

                if (dataForm.ImageIsChange && res?.Resultado > 0) {
                    let res = await UIUtilViewAlumno._SvActualizarFoto(dataForm, dataForm.Foto);
                    if (res.Resultado > 0) {
                        MainPage._ReloadService(this.GRID_GetDataRequestID(), dataForm.IdKinder);
                    }
                }

                if ([-6, -9].includes(res?.Resultado)) {
                    (res.Resultado == -6 && UIUtilViewAlumno._AlumnoCargosPendientesModal(datoOrigin, res.intentType));
                    (res.Resultado == -9 && UIUtilViewAlumno._AlumnoCargosPorProcesar(datoOrigin, res.intentType));
                    mt.Modal._Ocultar();
                    return null;
                }

                if ((dataForm.IdChildMovimiento == CNinioMovimiento.BajaTemporal || dataForm.IdKinder == form._DataOrigin.IdKinder) && res?.Resultado > 0) {
                    MainPage._ReloadService(Entidad.CTipoRequest.AlumnoEstado, dataForm.IdKinder);
                }
                return res;
            }
        })
    }

    private OpenModal_EliminarDatos(datos: Array<IAlumno>) {
        let infoBajasDefinitivas: { Disabled: boolean, DisabledMessage: string, Alumno: IAlumno }[] = [];
        datos.forEach(alumno => {
            let infoBajaDefinitiva = UIUtilViewAlumno._GetDisableToBajaDefinitiva(alumno);
            infoBajasDefinitivas.push({ ...infoBajaDefinitiva, Alumno: alumno });
        })
        if (infoBajasDefinitivas)
            this.GridOpenModal_ProccessArrayData({
                Title: "action_bajadefinit", // "Baja definitiva",
                Message: _L("alumnos.confirma_bajadef_msg2", datos.length.toString()), // `¿Estás segur@ que deseas dar de baja de manera definitiva a los alumnos seleccionados (${datos.length})?`,
                DataToProccess: infoBajasDefinitivas.filter(d => !d.Disabled).map(d => d.Alumno),
                OnDrawContent: (content, mt) => {
                    if (!infoBajasDefinitivas.filter(d => d.Disabled).length) return;

                    content.classed("modal_container_list_err", true);
                    let listContainer = content.append("div").classed("list_err_container", true);
                    listContainer.append("span").text("Alumnos no disponibles para baja definitiva:");

                    let listBody = listContainer.append("div").classed("list_err", true);
                    infoBajasDefinitivas.filter(d => d.Disabled).forEach(unavailableBajas => {
                        let listItem = listBody.append("div");
                        listItem.append("span")
                            .text(unavailableBajas.Alumno.NombreCompleto);
                        listItem.append("i")
                            .classed("detail", true)
                            .text(unavailableBajas.DisabledMessage);
                    })
                },
                AccionToHttpMessage: "editar",
                OnError_GetItemDataTag: (dato) => dato.NombreCompleto,
                OnGetIdEscuela: (dato) => dato.IdKinder,
                OnStepAProccess: (dato) => {
                    return UIUtilViewAlumno._SvCambiarEstadoEscolar(dato, CNinioMovimiento.BajaDefinitiva);
                },
                OnEndAndCloseProccess: (correctos, idsEscuelas) => {
                    if (correctos.length) {
                        MainPage._ReloadService(Entidad.CTipoRequest.HorarioAlumno, idsEscuelas);
                    }
                }
            })
    }

    private OpenModal_CargaMasiva() {
        type TGeneralData = {
            IdEscuela: number;
            IdEscolaridad: number;
            IdGrado: number;
        }
        let formRegistrar: FormGenerator<TGeneralData>;
        ExcelThingsV2._UploadExcelData<Entidad.IDataNinioCargaMasiva>({
            ValidateUniqueItems: true,
            TableId: "Alumnos-CargaMasiva",
            TableMinWidth: 1800,
            Columns: [
                {
                    Field: "Matricula", Label: this.VB_GetUIStringModule("d_field_matricula"), Required: false, UIMinWidthTH: "80px", UniqueValue: true,
                    OnGetErrorType: (value: string) => {
                        const matriculaExist = DataModuloMain._GetReqDataArrayByName("Alumno")
                            .find(d => (d.Matricula === (value?.trim() || undefined)));
                        return {
                            ErrorType: "matricula_exist",
                            Valid: !Boolean(matriculaExist),
                        }
                    },
                    OnGetErrorMessage: (value, errorType) => {
                        if (errorType == "matricula_exist") {
                            return this.VB_GetUIStringModule("error_matricula_existe");
                        }
                        return null;
                    },
                },
                { Field: "Nombre", Label: this.VB_GetUIStringModule("d_field_nombre"), Required: true, UIMinWidthTH: "100px" },
                { Field: "ApPaterno", Label: this.VB_GetUIStringModule("d_field_appaterno"), Required: true, UIMinWidthTH: "100px" },
                { Field: "ApMaterno", Label: this.VB_GetUIStringModule("d_field_apmaterno"), Required: false, UIMinWidthTH: "100px" },
                {
                    Field: "FechaNacimiento", Label: this.VB_GetUIStringModule("d_field_fechanacimiento"),
                    Required: false, UIMinWidthTH: "100px", ValueFormat: "dt_ddmmyyyy", RequiredValueType: "date_localUTC",
                },
                { Field: "Sexo", Label: this.VB_GetUIStringModule("d_field_strsexo"), Required: false, UIMinWidthTH: "100px", ValueFormat: "genero", RequiredValueType: "enumsexo" },
                { Field: "NombreT", Label: this.VB_GetUIStringModule("tag_nombret"), Required: true, UIMinWidthTH: "100px" },
                { Field: "ApPaternoT", Label: this.VB_GetUIStringModule("tag_appaternot"), Required: true, UIMinWidthTH: "100px" },
                { Field: "ApMaternoT", Label: this.VB_GetUIStringModule("tag_apmaternot"), Required: false, UIMinWidthTH: "100px" },
                { Field: "TelefonoT", Label: this.VB_GetUIStringModule("tag_telefonot"), Required: true, UIMinWidthTH: "100px", ValueFormat: "phonenumber" },
                {
                    Field: "CorreoT", Label: this.VB_GetUIStringModule("tag_correot"), Required: true, UIMinWidthTH: "200px",
                    ValueFormat: "email", UniqueValue: true,
                    // OnGetErrorType: (correo: string) => {
                    //     const correoF = correo.trim().toLowerCase();
                    //     let correoExistente = DataModuloMain.fn_GetReqDataArrayByName("Tutor")
                    //         .find((tutor) => (correoF == tutor.Correo.trim().toLowerCase())) != null;
                    //     return {
                    //         ErrorType: correoExistente ? "correo_existe" : null,
                    //         Valid: !correoExistente
                    //     }
                    // },
                    // OnGetErrorMessage: (value, errorType) => (errorType == "correo_existe") ? this.VB_GetUIStringModule("error_email_existe") : null,
                },
            ],
            OnGetTemplateFile: () => _SvArchivoPlantillaAlumnosObtenerExcel(),
            ConfigActionUploadSelection: {
                TypeUpload: "allByOne",
                OnCallBeforeToProccess: () => new Promise<boolean>(resolve => {
                    ModalThings._GetModalToForm({
                        Title: UIUtilLang._GetUIString("crgamasiva", "tag_assignregts"),
                        Width: 400,
                        GetForm: () => (formRegistrar = new FormGenerator<TGeneralData>()._Crear({
                            LabelMaxWidth: 120,
                            schema: [
                                {
                                    type: Fields.selectMaterial,
                                    model: "IdEscuela",
                                    labelAttr: { text: UIUtilLang._GetUIString("crgamasiva", "tag_esc") },
                                    selectMaterialAttr: {
                                        valueMember: "IdKinder", displayMember: "Nombre", required: true,
                                        onChange: (idKinder) => {
                                            let listEscolaridad = DataModuloMain._GetReqDataArrayByName("Escolaridad", true)
                                                .filter(d => d.IdEscuela == idKinder);

                                            (<SelectV2>formRegistrar._ControlsData.get("IdEscolaridad").instance)
                                                ._ResetSelect()
                                                ._UpdateList(listEscolaridad);

                                            (<SelectV2>formRegistrar._ControlsData.get("IdGrado").instance)
                                                ._ResetSelect()
                                                ._UpdateList([]);
                                        }
                                    },
                                    values: DataModuloMain._GetReqDataArrayByName("Escuela", true)
                                },
                                {
                                    type: Fields.selectMaterial,
                                    model: "IdEscolaridad",
                                    labelAttr: { text: UIUtilLang._GetUIString("crgamasiva", "tag_nivel") },
                                    selectMaterialAttr: {
                                        valueMember: "Id", displayMember: "Nombre", required: true,
                                        onChange: (idEscolaridad) => {
                                            let listGrados = DataModuloMain._GetReqDataArrayByName("Grado", true)
                                                .filter(d => (d.IdEscolaridad == idEscolaridad));

                                            (<SelectV2>formRegistrar._ControlsData.get("IdGrado").instance)
                                                ._ResetSelect()
                                                ._UpdateList(listGrados);
                                        }
                                    },
                                    values: []
                                },
                                {
                                    type: Fields.selectMaterial,
                                    model: "IdGrado",
                                    labelAttr: { text: UIUtilLang._GetUIString("crgamasiva", "tag_grado") },
                                    selectMaterialAttr: { valueMember: "IdNivel", displayMember: "Nombre", required: true },
                                    values: []
                                }
                            ],
                        }), formRegistrar),
                        OnClose: () => {
                            resolve(false);
                        },
                        OnAccept: (form, mt) => {
                            resolve(true);
                            mt.Modal._Ocultar();
                            return null;
                        }
                    })
                }),
                OnCallService: async (datos) => {
                    let datosGen = formRegistrar._Data;
                    let res = await _SvAlumnoCargaMasiva(
                        datosGen.IdEscuela,
                        datosGen.IdGrado,
                        datosGen.IdEscolaridad,
                        datos
                            .map(d => {
                                let dataReal = Object.assign({}, d);
                                if (dataReal.FechaNacimiento) {
                                    dataReal.FechaNacimiento = new DateV2(dataReal.FechaNacimiento as any as Date)
                                        ._SetTimeZone(DataModuloMain._GetDataValueFieldByName("Escuela", datosGen.IdEscuela, "ZonaHoraria"), true)
                                        ._ToISOString();
                                }
                                delete dataReal._ID;
                                return dataReal;
                            })
                    );
                    if (res.Resultado > 0) {
                        await MainPage._ReloadServiceAndAwaitBool(Entidad.CTipoRequest.Alumno);
                        await MainPage._ReloadServiceAndAwaitBool(Entidad.CTipoRequest.Tutor);
                        await MainPage._ReloadServiceAndAwaitBool(Entidad.CTipoRequest.TutorAsignacion);
                    }
                    if (res.Resultado < 0) {
                        res.Mensaje = UIUtilLang._GetHTTPMessage(res, "cargamasiva").replace("_C", res.Mensaje);
                    }
                    return res;
                }
            }
        });
    }

    private OpenModal_Circulares(alumnos: IAlumno[]) {
        interface IAlumnosEscuela {
            IdsAlumnos: number[];
            IdEscuela: number;
            NombreEscuela: string;
        }
        const arrAlumnosEscuela: IAlumnosEscuela[] = Array.from(d3Group(alumnos, d => d.IdKinder).values())
            .map<IAlumnosEscuela>((d: IAlumno[]) => ({
                IdEscuela: d[0].IdKinder,
                IdsAlumnos: d.map(d => d.IdChild),
                NombreEscuela: d[0].NombreKinder
            }));
        this.GridOpenModal_ActionFormToAGridData({
            Title: "tag_enviar_circular",
            GetForm: () => UIUtilViewCircular._GetNoticeForm(Entidad.CModulo.PanelCircular, Entidad.CAccionPermiso.Agregar, "childPanel").Form,
            OnAccept: async (form, modalThings) => {
                let dataForm = form._Data;
                interface DataProcess {
                    Resultado: number,
                    ItemData: IAlumnosEscuela,
                    TipoRequest: Entidad.CTipoRequest
                }

                let dataProcess = arrAlumnosEscuela.map<DataProcess>(alumnosEsc => ({
                    Resultado: -1,
                    ItemData: alumnosEsc,
                    TipoRequest: Entidad.CTipoRequest.Circular,
                }))
                await ModalThings._ProccessServiceByServiceFromAArrayIterator(modalThings, dataProcess, {
                    OnStepAProccess: async (item) => {
                        return _SvNoticiaNueva("ByAlumnos", <IMapSendCincularItems["ByAlumnos"]>{
                            IdEscuela: item.IdEscuela,
                            Titulo: dataForm.Titulo,
                            Mensaje: dataForm.Mensaje,
                            Archivo: ((dataForm.Archivo as any instanceof File) ? dataForm.Archivo : null) as any as File,
                            Programado: dataForm.Programado,
                            ReqAutorizacion: dataForm.ReqAutorizacion,
                            IdAlumnos: item.IdsAlumnos
                        })
                    },
                    OnError_GetItemDataTag: (itemData) => itemData.NombreEscuela,
                    Action: Entidad.CAccionPermiso.Agregar,
                    GeneralErrMessage: this.VB_GetUIStringModule("msg_sendcirc_err"),
                }).catch((err) => { console.log(err); return null; });

                modalThings.Modal._Ocultar();
                return null;
            },
        })
    }

    protected GRID_GetExportarConfig(dataGrid: IAlumno[]): IConfigGridExcelExport<IAlumno> {
        return {
            IdsEscuelas: [... new Set(dataGrid.map(d => (d.IdKinder)))],
            ColumnsConfig: this.ctrlTabla
                ._InfoColumns
                .filter(d => (d.Field != "getThumbnailURL"))
                .map<ExcelThings.IColumnToExcelExportFileConfig<IAlumno>>(d => ({
                    Field: (d.Field == "FechaNacimiento" ? "getFechaNacimientoFmt" : d.Field),
                    HeaderTag: d.Label,
                    WidthCell: (d.Field == "NombreCompleto" ? 35 : 20),
                })),
            OnGetDataBySheets: async () => {
                return Array.from(d3Group(dataGrid, d => d.IdKinder))
                    .map<ExcelThings.ISheetConfig<IAlumno>>(([idEscuela, alumnos]) => ({
                        IdSheet: idEscuela,
                        SheetName: alumnos[0].NombreKinder,
                        Data: alumnos,
                    }))
            },
            OnGetEscuelasTagInSheet: (datos) => datos[0].NombreKinder
        }
    }

    // **********************************************************************************************
    // PANEL AND THINGS
    // **********************************************************************************************

    private PanelModeVerDetalle(idAlumno: number) {
        Router._DoHash("alumnos/alumnos/panel", {
            mode: "All",
            id: [idAlumno]
        })
    }

    private OpenPanelModeAsignarLogros(datos: IAlumno[]) {
        Router._DoHash("alumnos/alumnos/panel", {
            mode: "palumnologros",
            id: datos.map(d => d.IdChild)
        })
    }

    private OpenPanelModeInscribir(datos: IAlumno[]) {
        Router._DoHash("alumnos/alumnos/panel", {
            mode: "palumnohorariosgrupos",
            id: datos.map(d => d.IdChild)
        })
    }

    private OpenPanelModeCargosYDescuentos(datos: Array<IAlumno>) {
        Router._DoHash("alumnos/alumnos/panel", {
            mode: "palumnocargosdescuentos",
            id: datos.map(d => d.IdChild)
        })
    }

    private OpenPanelModeAsignarMaterias(datos: IAlumno[]) {
        Router._DoHash("alumnos/alumnos/panel", {
            mode: "palumnomaterias",
            id: datos.map(d => d.IdChild)
        })
    }

    // **********************************************************************************************
    // PROCESOS AUXILIARES
    // **********************************************************************************************

    /** Valída:
     * * (1) Todos los alumnos pertenecen a la misma escuela, escolaridad y grado.
     * * (2) Ningún alumno tiene horarios (asignaciones a grupos) dentro de su escuela actual (asignaciones válidas).
     * * (2) Ningún alumno está dado de baja temporal.
     * @param alumnosValidar
     */
    private AllStudentsValidToAsignSchedules(alumnosValidar: IAlumno[]) {
        const alumnoA = alumnosValidar[0];
        for (const alumnoX of alumnosValidar) {
            // El alumno está dado de baja temporal
            if (alumnoX.IdChildMovimiento == CNinioMovimiento.BajaTemporal) {
                return {
                    enable: false,
                    message: _L("alumnos.tlt_inscribir_fail_bajatemp", alumnoX.NombreCompleto)
                }
            }
            // No están en el mismo kinder
            if (alumnoA.IdKinder != alumnoX.IdKinder) {
                return {
                    enable: false,
                    message: _L("alumnos.tlt_inscribir_fail_nosameschool")
                }
            }
            // No están en el mismo nivel
            if (alumnoA.IdEscolaridad != alumnoX.IdEscolaridad) {
                return {
                    enable: false,
                    message: _L("alumnos.tlt_inscribir_fail_nosamelevel")
                }
            }
            // No están en el mismo grado
            if (alumnoA.IdGrado != alumnoX.IdGrado) {
                return {
                    enable: false,
                    message: _L("alumnos.tlt_inscribir_fail_nosamegrade")
                }
            }
            // Si el alumno tiene asignaciones de horario con algún grupo
            for (let alumnoHorarios of UIUtilViewAlumno._GetGruposInscritosValidos([alumnoX]).GruposHorariosValidosMap.values()) {
                if (alumnoHorarios.length > 0) {
                    return {
                        enable: false,
                        message: _L("alumnos.tlt_inscribir_fail_asignhorario")
                            .replace("_NAME", DataModuloMain._GetDataValueFieldByName("Alumno", alumnoHorarios[0].IdNinio, "NombreCompleto"))
                    }
                }
            }
        }
        return {
            enable: true,
            message: "",
        }
    }

    private AllStudentsToAsignLogros(students: IAlumno[]) {
        let allInSameSchool = students.every(d => (students[0].IdKinder == d.IdKinder));
        let noBajaTemporal = students.filter(d => d.IdChildMovimiento == CNinioMovimiento.BajaTemporal).length;
        if (!allInSameSchool) {
            return {
                enable: false,
                message: this.VB_GetUIStringModule("tlt_asign_fail_nosameschool")
            }
        }
        if (noBajaTemporal > 0) {
            return {
                enable: false,
                message: _L(students.length == 1 ? "alumnos.tlt_student_bajatemporal" : "alumnos.tlt_students_bajatemporal", noBajaTemporal)
            }
        }
        // let alumnoConLogros = students.find(d => (Data.Modulo.Alumno.fn_LOCALDATA_GetLogrosDeAlumno(d.IdChild).size > 0));
        // if (alumnoConLogros) {
        //     return {
        //         enable: false,
        //         message: this.VB_GetUIStringModule("tlt_logrosasign_fail_multasign")
        //     }
        // }
        return {
            enable: true,
        }
    }

    private AllStudentsToAsignMaterias(students: IAlumno[]) {
        let allInSameSchool = students.every(d => (students[0].IdKinder == d.IdKinder));
        let noBajaTemporal = students.filter(d => d.IdChildMovimiento == CNinioMovimiento.BajaTemporal).length;
        if (!allInSameSchool) {
            return {
                enable: false,
                message: this.VB_GetUIStringModule("tlt_asign_fail_nosameschool")
            }
        }
        if (noBajaTemporal > 0) {
            return {
                enable: false,
                message: _L(students.length == 1 ? "alumnos.tlt_student_bajatemporal" : "alumnos.tlt_students_bajatemporal", noBajaTemporal)
            }
        }
        return {
            enable: true,
        }
    }

    private AllStudentsToGetBoletas(students: IAlumno[]) {
        let allInSameSchool = students.every(d => (students[0].IdKinder == d.IdKinder));
        let noBajaTemporal = students.filter(d => d.IdChildMovimiento == CNinioMovimiento.BajaTemporal).length;
        if (!allInSameSchool) {
            return {
                enable: false,
                message: _L("alumnos.tlt_asign_fail_nosameschool")
            }
        }
        if (noBajaTemporal > 0) {
            return {
                enable: false,
                message: _L(students.length == 1 ? "alumnos.tlt_student_bajatemporal" : "alumnos.tlt_students_bajatemporal", noBajaTemporal)
            }
        }
        return {
            enable: true
        }
    }

    private OpenGenerarBoletas(alumnos: Array<IAlumno>) {
        const MapAlumnos = new Map<number, IAlumno>();
        alumnos.forEach(d => MapAlumnos.set(d.IdChild, d));
        const idEscuela = alumnos[0].IdKinder;
        let ctrlSelectCicloEscolar: SelectV2<MCicloEscolar, "Id">;
        let ctrlSelectPeriodo: SelectV2<IPeriodoD, "Id", "multiselect">;
        let inputInitRange: HTMLInputElement;
        let inputFinRange: HTMLInputElement;

        _ModalToAProccess({
            Title: "tag_periodo_generarboletas",
            LangModuleKeyInContext: "alumnos",
            DrawContent: (content, modalThings) => {
                let selectorsContainer = content.append("div")
                    .classed(UIUtilGeneral.FBoxOrientation.Vertical, true)
                    .style("gap", "24px")
                    .style("padding", "14px");

                ctrlSelectCicloEscolar = new SelectV2<MCicloEscolar, "Id">({
                    Type: "monoselect",
                    Parent: selectorsContainer,
                    DisplayMember: "Nombre",
                    ValueMember: "Id",
                    OnChange: (vm, data) => {
                        ctrlSelectPeriodo._RefreshList();
                        if (ctrlSelectPeriodo._dataitems?.length) ctrlSelectPeriodo._valueSelect(ctrlSelectPeriodo._dataitems[0].Id);
                        this.updateMinMaxDateRange(ctrlSelectPeriodo._dataSelected, inputInitRange, inputFinRange);
                    },
                    Data: () => this.GetCiclosEscolaresList(idEscuela),
                });
                selectorsContainer.append(() => ElementWrapper._WrapperToSelectControl(ctrlSelectCicloEscolar, this.VB_GetUIStringModule("tag_cicloesc")).node());
                const ciclosEscolaresList = ctrlSelectCicloEscolar._dataitems;
                let cicloEscCurrent: MCicloEscolar;
                if (!ctrlSelectCicloEscolar._dataValueMemberSelected.length) {
                    cicloEscCurrent = this.GetCurrentCicloEscolar(ciclosEscolaresList, idEscuela);
                    ctrlSelectCicloEscolar._valueSelect(cicloEscCurrent?.Id);
                }

                ctrlSelectPeriodo = new SelectV2<IPeriodoD, "Id", "multiselect">({
                    Type: "multiselect",
                    Parent: selectorsContainer,
                    DisplayMember: "Name",
                    ValueMember: "Id",
                    OnChange: (_, data) => {
                        this.updateMinMaxDateRange(data, inputInitRange, inputFinRange);
                    },
                    Data: () => this.GetPeriodosListFromCicloEscolar(ctrlSelectCicloEscolar._dataSelected[0]),
                })
                selectorsContainer.append(() => ElementWrapper._WrapperToSelectControl(ctrlSelectPeriodo, this.VB_GetUIStringModule("tag_period")).node());
                const periodosList = ctrlSelectPeriodo._dataitems;
                if (!ctrlSelectPeriodo._dataValueMemberSelected.length) {
                    const periodoCurrent = this.GetInitPeriodoFromCicloEsc(cicloEscCurrent, periodosList);
                    ctrlSelectPeriodo._valueSelect(periodoCurrent?.Id);
                }

                selectorsContainer.append("label")
                    .text(_L("alumnos.tag_generarboleta_filtro_opcional"))
                    .style("font-family", "Lato-Bold")

                let dateRangeContainer = selectorsContainer.append("div")
                    .style("display", "flex")
                    .style("flex-flow", "row")
                    .style("gap", "10px")

                inputInitRange = dateRangeContainer.append("input")
                    .attr("type", "date")
                    .node();

                dateRangeContainer.append(() => ElementWrapper._WrapperToElement(inputInitRange, "Inicio").node());

                inputFinRange = dateRangeContainer.append("input")
                    .attr("type", "date")
                    .node();

                this.updateMinMaxDateRange(ctrlSelectPeriodo._dataSelected, inputInitRange, inputFinRange);
                dateRangeContainer.append(() => ElementWrapper._WrapperToElement(inputFinRange, "Fin").node());
            },
            OnAccept: async (mt) => {
                const [cicloEscolarSelectedId] = ctrlSelectCicloEscolar._dataValueMemberSelected;
                const [cicloEscolarSelected] = ctrlSelectCicloEscolar._dataSelected;
                const periodosSelected: string[] = ctrlSelectPeriodo._dataSelected.map(d => new Date(d.Year, d.Month, 2).toISOString())
                let dtInitRange: DateV2;
                let dtFinRange: DateV2;

                let strInitRange = inputInitRange.value;
                let strFinRange = inputFinRange.value;

                let usesDateRange = false;
                if ((strInitRange || strFinRange) || (!inputInitRange.validity.valid || !inputFinRange.validity.valid)) { // SI ALGUNO DE LOS DOS INPUTS TIENEN VALOR
                    if ((!inputInitRange.validity.valid || !inputFinRange.validity.valid) || (!strInitRange || !strFinRange)) { NotificacionV2._Mostrar(_L("alumnos.notif_erro_filterrange"), "ADVERTENCIA"); return; }
                    dtInitRange = new DateV2(UIUtilTime._GetLocalDateFromInputDateString(inputInitRange.value))._SetTimeZoneByIdSchool(idEscuela, true);
                    dtFinRange = new DateV2(UIUtilTime._GetLocalDateFromInputDateString(inputFinRange.value))._SetTimeZoneByIdSchool(idEscuela, true);
                    dtFinRange.setDate(dtFinRange.getDate() + 1);
                    dtFinRange.setMilliseconds(dtFinRange.getMilliseconds() - 1)
                    if (dtFinRange.getTime() < dtInitRange.getTime()) { NotificacionV2._Mostrar(_L("alumnos.notif_erro_filterrange"), "ADVERTENCIA"); return; }
                    usesDateRange = true;
                }

                if (!cicloEscolarSelectedId) { NotificacionV2._Mostrar(_L("alumnos.notif_selectperiod_tocontinue"), "ADVERTENCIA"); return }
                if (!periodosSelected?.length) { NotificacionV2._Mostrar(_L("alumnos.notif_selectperiod_tocontinue"), "ADVERTENCIA"); return }

                const [cicloEscolarSelectedInfo] = ctrlSelectCicloEscolar._dataSelected;
                const periodosDtSelected: Date[] = ctrlSelectPeriodo._dataSelected.map(d => new DateV2(new Date(d.Year, d.Month, 1))._SetTimeZoneByIdSchool(idEscuela, true));
                const { dtInicio, dtFin } = UIUtilViewCalificacion._GetInitAndEndInPeriodosList(periodosDtSelected);

                const strInit = dtInicio._ToISOLocalString();
                const strFin = dtFin._ToISOLocalString();

                mt.Progress.attr("oculto", false);
                // EN SERVICIO SE AJUSTA LA FECHA DE EVALUACIÓN A LA ZONA DE LA ESCUELA // LAS FECHAS DE LOS PERIODOS Y DE EVALUACIONES SON TRUNCADAS AL MES
                let resCalificaciones = await _SvAlumnoGetBoletaCalificacionesV2(alumnos.map(d => d.IdChild), cicloEscolarSelectedId, periodosSelected);
                mt.Progress.attr("oculto", true);

                if (resCalificaciones.Resultado < 1) { NotificacionV2._Mostrar(_L("general.notif_fail"), "ADVERTENCIA"); return; }
                if (!resCalificaciones.Datos?.length) { NotificacionV2._Mostrar(_L("alumnos.notif_nocalifreg"), "ADVERTENCIA"); return; }

                const BoletasAlumnos: IAlumnoBoleta[] = [];
                let allStudentsCalif = resCalificaciones.Datos;
                allStudentsCalif = allStudentsCalif.filter(calif => {
                    const iDelete: number[] = [];
                    calif.FechasEval.forEach((evalFecha, i) => {
                        const dtEval = new DateV2(evalFecha)._SetTimeZoneByIdSchool(idEscuela, true);
                        let dateInRange = false;
                        dateInRange = UIUtilViewCalificacion._IsDateInRange(dtEval, periodosDtSelected, (usesDateRange) ? { dtInitRange: dtInitRange, dtFinRange: dtFinRange } : null)
                        if (!dateInRange) iDelete.push(i);
                    })
                    iDelete.forEach((iPos, i) => { calif.Evaluaciones.splice(iPos - i, 1); calif.FechasEval.splice(iPos - i, 1); calif.IdsEvaluaciones.splice(iPos - i, 1); calif.IdsEvaluadores.splice(iPos - i, 1); calif.Observaciones.splice(iPos - i, 1); })
                    const auxInfoEvaluaciones: UIUtilViewCalificacion.IAuxInfoEvaluaciones[] = calif.Evaluaciones
                        .map((d, i) => ({
                            Evaluacion: calif.Evaluaciones[i],
                            FechaEval: calif.FechasEval[i],
                            IdEvaluacion: calif.IdsEvaluaciones[i],
                            Observacion: calif.Observaciones[i],
                            TipoEval: calif.Tipo,
                            IdEvaluador: calif.IdsEvaluadores[i],
                        }))
                    auxInfoEvaluaciones.sort((a, b) => descending(a.IdEvaluacion, b.IdEvaluacion));
                    auxInfoEvaluaciones.sort((a, b) => descending(a.FechaEval, b.FechaEval));
                    calif.Evaluacion = [UIUtilViewCalificacion._GetEvalGral(auxInfoEvaluaciones.map(d => d.Evaluacion), calif.Tipo)[0]].join("\r\n");
                    return calif.Evaluaciones.length > 0;
                })

                if (!allStudentsCalif.length) { NotificacionV2._Mostrar(_L("alumnos.notif_nocalifreg"), "ADVERTENCIA"); return; }
                let idsStudentsWithQualif: number[] = Array.from(d3Group(allStudentsCalif, d => d.IdAlumno).keys());
                let studentsWithQualif = idsStudentsWithQualif.map(d => MapAlumnos.get(d));

                await _ProccessAndValidateBoletasData({
                    Students: studentsWithQualif,
                    SchoolId: studentsWithQualif[0].IdKinder,
                    CicloEscolar: cicloEscolarSelected,
                    PeriodsDtSelected: periodosDtSelected,
                    RangeStartDate: strInit,
                    RangeEndDate: strFin,
                    FilterAbsencesCfg: (usesDateRange) ? { startRangeDate: dtInitRange, endRangeDate: dtFinRange } : null,
                    toggleProgress: (show) => {
                        mt.Progress.attr("oculto", !show);
                    },
                    onTemplateLoadError: (resultCode) => {
                        if (resultCode < 1) {
                            let errNotifMsg = "";
                            if (resultCode != -1)
                                errNotifMsg = _L("general.notif_fail");
                            else
                                errNotifMsg = _L("calificacion.notif_errload_boletascfg");
                            NotificacionV2._Mostrar(errNotifMsg, "ADVERTENCIA", 4500);
                        }
                    },
                    onReportInfoError: () => {
                        NotificacionV2._Mostrar(_L("general.notif_fail"), "ADVERTENCIA");
                    },
                    onBoletaAlreadyInPeriod: (studentsWithErrors) => {
                        console.warn("");
                    },
                    onPeriodsAfterWithBoleta: (studentsWithErrors) => {
                        console.warn();
                    },
                    onBoletaMissingPeriods: async (studentsWithErrors) => {
                        console.warn("");
                    },
                    onBoletasLimitExceeded: (studentsWithErrors) => {
                        if (studentsWithErrors.length) {
                            _ModalInfoDataList({
                                Title: _L("alumnos.tag_title_boletasenciclo"),
                                InfoText: _L("alumnos.msg_err_boletasexceeded").replace("_CICLOESC", `<b>${cicloEscolarSelectedInfo.Nombre}</b>`) + ":",
                                DataList: studentsWithErrors,
                                OnStepItemData(content, itemData) {
                                    content.text(itemData.NombreCompleto);
                                }
                            })
                        }
                    },
                    getEvaluationsForStudent: (studentId) => {
                        let alumnoCalif = d3Group(allStudentsCalif, d => d.IdAlumno).get(studentId);
                        const calificaciones: IElementoCalificado[] = alumnoCalif.map(elCalificado => {
                            const evaluaciones = elCalificado.Evaluacion.split("\r\n");
                            if (elCalificado.Tipo == CTipoEvaluacion.Numeros)
                                evaluaciones.forEach((d, i) => { evaluaciones[i] = Number(d).toFixed(1) });

                            return {
                                ...elCalificado,
                                EvaluacionArr: evaluaciones,
                                AuxInfoEvaluaciones: elCalificado.Evaluaciones
                                    .map((d, i) => ({
                                        Evaluacion: elCalificado.Evaluaciones[i],
                                        FechaEval: elCalificado.FechasEval[i],
                                        IdEvaluacion: elCalificado.IdsEvaluaciones[i],
                                        Observacion: elCalificado.Observaciones[i],
                                        IdEvaluador: elCalificado.IdsEvaluadores[i],
                                        TipoEval: elCalificado.Tipo,
                                    }))
                                    .sort((a, b) => b.FechaEval.localeCompare(a.FechaEval)),
                            }
                        });
                        return calificaciones;
                    },
                    onEvaluationIdRepeatError: (errors) => {
                        _ModalInfoDataList({
                            Title: _L("alumnos.tag_title_evaluacionesrepeat"),
                            InfoText: _L("alumnos.msg_err_evaluacionesrepeat"),
                            DataList: errors,
                            OnStepItemData(content, itemData) {
                                content.append("b").text(`${itemData.NombreCompleto}: `);
                                content.append("span").text(`${itemData.PeriodsErr.map(d => "Periodo " + d).join(", ")}`);
                            }
                        })
                    },
                    onProcessingComplete: ({ boletasData, auxInfo }) => {
                        _GenerarBoletasModal({
                            StudentsBoletasData: boletasData,
                            AssignmentsInfo: auxInfo
                        })
                        mt.Modal._Ocultar();
                    },
                })
                return null;
            },
        })
    }

    private updateMinMaxDateRange(periodos: IPeriodoD[], inputInitRange: HTMLInputElement, inputEndRange: HTMLInputElement) {
        if (!periodos.length) {
            inputInitRange.min = null; inputInitRange.max = null;
            inputEndRange.min = null; inputEndRange.max = null;
            return;
        }

        const periodosDtSelected: Date[] = periodos.map(d => new Date(d.Year, d.Month, 1));
        periodosDtSelected.sort((a, b) => ascending(a.getTime(), b.getTime()));
        let dtInicio = new Date(periodosDtSelected[0]);
        let dtFin = new Date(periodosDtSelected[periodosDtSelected.length - 1]);
        dtFin.setMonth(dtFin.getMonth() + 1);
        dtFin.setMilliseconds(dtFin.getMilliseconds() - 1);
        const minInput = UIUtilTime._FmtToInputDate(dtInicio);
        const maxInput = UIUtilTime._FmtToInputDate(dtFin);
        inputInitRange.min = minInput;
        inputInitRange.max = maxInput;
        inputEndRange.min = minInput;
        inputEndRange.max = maxInput;
    }

    private GetCiclosEscolaresList(idEscuela: number) {
        let ciclosEscolaresList = Array.from(_DICC_CICLO_ESCOLAR.values())
            .filter(dCiclo => (dCiclo.IdEscuela == idEscuela))
            .sort((a, b) => Number(new Date(b.FechaInicio)) - Number(new Date(a.FechaInicio)))

        return (ciclosEscolaresList || []);
    }

    private GetCurrentCicloEscolar(ciclosEscolares = Array.from(_DICC_CICLO_ESCOLAR.values()), idEscuela: number): (MCicloEscolar | null) {
        const now = new DateV2()._SetTimeZoneByIdSchool(idEscuela).getTime();
        let cicloEsc = ciclosEscolares
            .filter(dCiclo => (dCiclo.IdEscuela == idEscuela))
            .find(d =>
                new DateV2(d.FechaInicio)._SetTimeZoneByIdSchool(idEscuela).getTime() <= now
                && new DateV2(d.FechaFin)._SetTimeZoneByIdSchool(idEscuela).getTime() >= now
            );

        if (!cicloEsc) {
            cicloEsc = ciclosEscolares[0];
        }

        return cicloEsc;
    }

    private GetPeriodosListFromCicloEscolar(cicloEscolar: MCicloEscolar): IPeriodoD[] {
        let periodos: IPeriodoD[] = [];

        if (cicloEscolar) {
            periodos = cicloEscolar._GetMonthPeriods(true).map(d => ({ ...d, EnCicloEscolar: true }));
        }

        return periodos;
    }

    private GetInitPeriodoFromCicloEsc(cicloEscolar: MCicloEscolar, periodos = this.GetPeriodosListFromCicloEscolar(cicloEscolar)) {
        const now = new Date();

        let periodo = periodos
            .find(d => d.Month == now.getMonth() && d.Year == now.getFullYear());

        if (!periodo && periodos) {
            periodo = periodos[0]
        }

        return periodo;
    }
}
